module.exports = __webpack_public_path__ + "img/level.77801013.png";